export class FeatureConstants {
  static readonly holidayReferenceCalendar = 'AgenticCX.HolidayReferenceCalendar';
  static readonly queueAnnouncements = 'AgenticCX.QueueAnnouncements';
}
